import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";

import {
  addProductStyleAsync,
  addProductsizeAsync,
  deleteProductsizeAsync,
  editProductStyleAsync,
  editProductsizeAsync,
  getProductStyleAsync,
  getProductsizeAsync,
} from "../../../../store/services/productInfoServices";


const Size = () => {
  const dispatch = useDispatch();
  const {
    getProductsizeStatus,
    getProductsizeError,
    getProductsizeData,
    addProductsizeStatus,
    addProductsizeData,
    addProductsizeError,

    editProductsizeStatus,
    editProductsizeError,
    editProductsizeData,

    deleteProductsizeData,
    deleteProductsizeStatus,
    deleteProductsizeError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductsizeAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductsizeData?.length
    ? getProductsizeData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedsize, setSelectedsize] = useState();
  const [addsizeMode, setAddsizeMode] = useState(false);
  const [addsizeData, setAddsizeData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedsize", selectedsize);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductsizeStatus === asyncStatus.SUCCEEDED) {
      setAddsizeMode(false);
      setSaveDisabled(true);
      setAddsizeData();
    }
  }, [, addProductsizeStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductsizeAsync(selectedsize?.size_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductsizeStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedsize();
    }
  }, [, deleteProductsizeStatus]);
  useEffect(() => {
    if (editProductsizeStatus === asyncStatus.SUCCEEDED) {
      setSelectedsize();
      setEditMode(false);
    }
  }, [, editProductsizeStatus]);
console.log("getProductsizeData",getProductsizeData,editProductsizeData);




  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this size?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Fit Category"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Size Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddsizeMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addsizeMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addsizeMode || !selectedsize}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddsizeMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addsizeMode || !selectedsize}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductsizeStatus === asyncStatus.LOADING ||
                  editProductsizeStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addsizeData) {
                    dispatch(addProductsizeAsync(addsizeData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedsize, ...editData };
                    delete a.id;
                    dispatch(editProductsizeAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "size_id", headerName: "ID", flex: true },
                  {
                    field: "size_name",
                    headerName: "size Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedsize(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductsizeStatus === asyncStatus.IDLE ||
                  getProductsizeStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addsizeMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Size:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddsizeData({
                            ...addsizeData,
                          size_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddsizeData({
                            ...addsizeData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedsize ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedsize?.size_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Size:",
                    comp: (
                      <InputComp
                        key={selectedsize?.size_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                          size_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedsize?.size_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedsize?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedsize?.is_active ? true : false
                        }
                        checked={selectedsize?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any size</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductsizeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductsizeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductsizeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductsizeError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedsize(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedsize(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default Size;
